// extracted by mini-css-extract-plugin
module.exports = {"pageErrorBoundary":"PageErrorBoundary_pageErrorBoundary__1iqjV","buttonContainer":"PageErrorBoundary_buttonContainer__1ATXV"};